import React from 'react';
import { CircularProgress } from '@mui/material';

const Loader = ({
  loading,
  loadingText = "Loading Please Wait",
  emptyText = "No Data Found",
  hideText = false,
  iconWidth = 30,
  height = "100%",
  minHeight = 300,
  classNameLoader = ""
}) => {
  return (
    <div
      className={classNameLoader}
      style={{
        width: '100%',
        height: height,
        minHeight: typeof minHeight === 'number' ? `${minHeight}px` : minHeight,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: '15px',
        gap: '10px',
        flexDirection: 'row'
      }}
    >
      {loading ? (
        <>
          {!hideText && loadingText}
          <CircularProgress
            size={hideText ? iconWidth : 20}
            thickness={5}
            sx={{
              '& .MuiCircularProgress-circle': {
                stroke: 'url(#loader-gradient)',
              },
            }}
          />
          <svg width="0" height="0">
            <defs>
              <linearGradient id="loader-gradient" x1="1" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#EC691F" />
                <stop offset="100%" stopColor="#0160C6" />
              </linearGradient>
            </defs>
          </svg>
        </>
      ) : (
        !hideText && emptyText
      )}
    </div>
  );
};

export default Loader;